import React, { Component } from "react";

export default class HomePageFooter extends Component {
	render() {
		return (
			<footer className="mdl-mini-footer py-4">
				<div className="mdl-mini-footer__left-section text-center w-100">
					<p className="m-0">
						Copyright © MeetingSpace 2019. Made by Shakil Ahmed
					</p>
				</div>
			</footer>
		);
	}
}
